export const en = {
    users: {
        list: {
            firstName: "First Name",
            lastName: "Last Name",
            role: "Role",
            entity: "Entity",
        },
        alerts: {
            create: {
                title: "Create User",
                text: "Are you sure you want to create <b>%{user}</b>",
                success: {
                    title: "User Created Successfully",
                    text: "<b>%{user}</b> was created successfully",
                },
                error: {
                    title: "User Create Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            delete: {
                title: "Delete User",
                text: "Are you sure you want to delete <b>%{user}</b>",
                success: {
                    title: "User Deleted Successfully",
                    text: "You will now be redirected to the users page",
                },
                error: {
                    title: "User Delete Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            edit: {
                title: "Edit User",
                text: "Are you sure you want to edit <b>%{user}</b>",
                success: {
                    title: "User Edited Successfully",
                    text: "<b>%{user}</b> was edited successfully",
                },
                error: {
                    title: "User Edit Error",
                    text: "Something went wrong. Please try again later",
                }
            }
        },
        form: {
            headers: {
                create: "Create User",
                edit: "Edit User",
                view: "View User"
            },
            firstName: {
                label: "First Name",
            },
            lastName: {
                label: "Last Name",
            },
            email: {
                label: "Email",
            },
            role: {
                label: "Role",
            },
            entity: {
                label: "Entity",
            },
            status: {
                label: "Status",
                enabled: "Enabled",
                disabled: "Disabled",
            },
            language: {
                label: "Language",
                english: "English"
            },
            timezone: {
                label: "Timezone",
                europeLisbon: 'Europe/Lisbon',
                utc: 'UTC'
            },
        },
        errors: {
            invalidEmail: "Invalid email format",
            USER_ACCOUNT_ALREADY_ACTIVATED: "User is already active. If you tried to reset the password, it means that you cannot reset your password until you fill the \"Forgot Password\" form.",
            specialCharacters: "Special characters are not allowed."
        },
        permissions: {
            USERS: "Users",
            CREATE_USER: "Create users",
            READ_USER: "Read users",
            UPDATE_USER: "Update users",
            DELETE_USER: "Delete users"
        }
    }
};